<template>
  <div class="bg-gray-200 w-96 flex flex-col">
    <div>
      <!-- Top Bar -->
      <div
        class="md:h-14 bg-white flex flex-row py-2 md:py-0 shadow-sm items-center justify-between text-left sticky top-0 md:pl-5 px-2 z-10"
      >
        <div class="text-gray-600 text-base font-semibold md:mt-0 mt-1 md:py-4">
          My Interview
        </div>
      </div>
      <!-- Top Bar END-->
      <AgGridTable
        v-if="isReadPermission"
        ref="myinterviews"
        :perPage="perPage"
        :columnDefs="columnDefs"
        :url="url"
        :enumValues="enumValues"
      />
      <NotAuthorized v-else />
      <TechnicalFeedbackModal
        :interview_obj="interview_obj"
        v-if="isTechnicalModalVisible"
        @close="closeFeedbackModal"
        @cancel="onCancel"
      />
      <HrFeedbackModal
        :interview_obj="interview_obj"
        v-if="isHrViewModalVisible"
        @close="closeFeedbackModal"
        @cancel="onCancel"
      />
      <ManagerFeedbackModal
        :interview_obj="interview_obj"
        v-if="isManagerViewModalVisible"
        @close="closeFeedbackModal"
        @cancel="onCancel"
      />
    </div>
  </div>
</template>

<script>
/*eslint-disable  vue/no-unused-components*/
import AgGridTable from '@/components/tables/AgGridTable.vue';
import { EditButtonCellRenderer } from '@/components/tables/renderers';
import TechnicalFeedbackModal from '@/components/recruitment/requirementList/TechnicalFeedbackModal.vue';
import HrFeedbackModal from '@/components/recruitment/requirementList/HrFeedbackModal.vue';
import ManagerFeedbackModal from '@/components/recruitment/requirementList/ManagerFeedbackModal.vue';
import CustomToolTip from './CustomToolTip.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'InterviewList',
  data() {
    return {
      isReadPermission: false,
      isManagePermission: false,
      isHrViewModalVisible: false,
      isTechnicalModalVisible: false,
      isManagerViewModalVisible: false,
      interview_obj: null,
      rowData: null,
      url: 'recruitment/interviews/userId/',
      perPage: 50,
      columnDefs: [
        {
          field: 'interview_obj',
          headerName: 'Feedback',
          cellRenderer: 'scoreCardRenderer',
          cellRendererParams: {
            clicked: (field) => {
              this.interview_obj = field;
              if (field.round_type === 'Technical') {
                this.isTechnicalModalVisible = !this.isTechnicalModalVisible;
              }
              if (field.round_type === 'Managerial') {
                this.isManagerViewModalVisible =
                  !this.isManagerViewModalVisible;
              }
              if (field.round_type === 'HR') {
                this.isHrViewModalVisible = !this.isHrViewModalVisible;
              }
            },
          },
        },

        {
          field: 'r_id',
          headerName: 'Req ID',
          sortable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            filterOptions: [
              'contains',
              'notContains',
              'equals',
              'notEqual',
              'startsWith',
              'endsWith',
              'blank',
              'notBlank',
            ],
          },
        },
        {
          field: 'job_role',
          headerName: 'Job Role',
          sortable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
          },
        },

        {
          field: 'first_name',
          headerName: 'First Name',
          sortable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
          },
        },
        {
          field: 'last_name',
          headerName: 'Last Name',
          sortable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
          },
        },

        {
          field: 'round_type',
          headerName: 'Interview Type',
          sortable: true,
          filter: 'agTextColumnFilter',
          colId: 'round_type',
          type: ['enumColumn.interview_type'],
          filterParams: {
            buttons: ['apply', 'reset'],
            filterOptions: [
              'contains',
              'notContains',
              'equals',
              'notEqual',
              'startsWith',
              'endsWith',
              'blank',
              'notBlank',
            ],
          },
          cellRenderer: (params) => {
            let bgColor = '';
            switch (params.value) {
              case 'Technical':
                bgColor =
                  'text-yellow-800 bg-yellow-200 px-2 py-1 text-sm rounded-full';
                break;
              case 'HR':
                bgColor =
                  'text-red-800 bg-red-200 px-2 py-1 text-sm rounded-full';
                break;
              case 'Managerial':
                bgColor =
                  'text-green-800 bg-green-200 px-2 py-1 text-sm rounded-full';
                break;
              default:
            }
            return (
              params.value && `<span class="${bgColor}">${params.value}</span>`
            );
          },
        },
         {
          field: 'round_number',
          headerName: 'Interview Round',
          sortable: true,
          filter: 'agNumberColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
          },
        },
        {
          field: 'date',
          headerName: 'Interview Date & Time',
          sortable: true,
          filter: 'agDateColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
            comparator: (filterLocalDateAtMidnight, cellValue) => {
              const dateAsString = cellValue;
              const dateParts = dateAsString.split('/');
              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
              }
              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }
              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
          },
        },
        {
          field: 'duration',
          headerName: 'Interview Duration',
          sortable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
          },
        },
        {
          field: 'mode',
          headerName: 'Interview Mode',
          sortable: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            buttons: ['apply', 'reset'],
          },
        },
        {
          field: 'interviewer',
          headerName: 'Interviewer',
          tooltipComponent: 'customTooltip',
          tooltipField: 'interviewer',
          minWidth: 250,
          maxWidth: 500,
          tooltipComponentParams: { color: '#ffffff' },

        },

        {
          field: 'pros',
          headerName: 'Pros',
          tooltipComponent: 'customTooltip',
          tooltipField: 'pros',
          tooltipComponentParams: { color: '#ffffff' },
        },
        {
          field: 'cons',
          headerName: 'Cons',
          tooltipComponent: 'customTooltip',
          tooltipField: 'cons',
          tooltipComponentParams: { color: '#ffffff' },
        },

        {
          field: 'interview_status',
          headerName: 'Status',
          filter: 'agTextColumnFilter',
          minWidth: 250,
          maxWidth: 400,
          sortable: true,
          filterParams: {
            buttons: ['apply', 'reset'],
            filterOptions: [
              'contains',
              'notContains',
              'equals',
              'notEqual',
              'startsWith',
              'endsWith',
              'blank',
              'notBlank',
            ],
          },
          cellRenderer: (params) => {
            let bgColor = '';
            switch (params.value) {
              case 'Rejected':
                bgColor =
                  'text-red-800 bg-red-200 font-semibold px-2 py-0 rounded-full';
                break;
              case 'On Hold':
                bgColor =
                  'text-yellow-800 bg-yellow-200 font-semibold px-2 py-0 rounded-full';
                break;
              case 'Selected For Next Round':
                bgColor =
                  'text-blue-800 bg-blue-200 font-semibold px-2 py-0 rounded-full';
                break;
              case 'Selected For Final Round':
                bgColor =
                  'text-green-800 bg-green-200 font-semibold px-2 py-0 rounded-full';
                break;
              default:
            }
            return (
              params.value && `<span class="${bgColor}">${params.value}</span>`
            );
          },
        },
        {
          field: 'feedback',
          headerName: 'Rating',
          filter: 'agTextColumnFilter',
          colId: 'feedback',
          sortable: true,
          type: ['enumColumn.interview_type'],
          filterParams: {
            buttons: ['apply', 'reset'],
            filterOptions: [
              'contains',
              'notContains',
              'equals',
              'notEqual',
              'startsWith',
              'endsWith',
              'blank',
              'notBlank',
            ],
          },
        },
      ],
      enumValues: {
        interview_type: {
          Technical: 'Technical',
          HR: 'HR',
          Managerial: 'Managerial',
        },
      },
    };
  },
  components: {
    AgGridTable,
    scoreCardRenderer: EditButtonCellRenderer,
    TechnicalFeedbackModal,
    ManagerFeedbackModal,
    HrFeedbackModal,
    customTooltip: CustomToolTip,
  },
  computed: {
    ...mapGetters('user', ['userId', 'isAdmin', 'userFullName']),
  },
  methods: {
    close() {
      this.$emit('close');
    },

    onCancel() {
      this.isHrViewModalVisible = false;
      this.isTechnicalModalVisible = false;
      this.isManagerViewModalVisible = false;      
    },

    closeFeedbackModal() {
      this.isHrViewModalVisible = false;
      this.isTechnicalModalVisible = false;
      this.isManagerViewModalVisible = false;
      this.$refs.myinterviews.updateDataSource();
    },
  },

  created() {
    this.isReadPermission = this.validatePermission([
      'recruitment.my_interview_list.read',
    ]);
    this.isManagePermission = this.validatePermission([
      'recruitment.my_interview_list.manage',
    ]);
  },
};
</script>
